module.exports = __webpack_public_path__ + "spa-static/img/twitter.e8aa0b5e.svg";